import { useEffect } from 'react';

export default function useKeyboardShortcuts(callback, active) {
  useEffect(() => {
    if (active) {
      const keyboardHandler = (e) => {
        if (['Enter', 'Space'].includes(e.key)) {
          callback();
        }
      };
      document.addEventListener('keyup', keyboardHandler);
      return () => document.removeEventListener('keyup', keyboardHandler);
    }
  }, [active]);
}
